






















































































import { Component, Vue, Watch } from 'vue-property-decorator'
import {
  SectionController,
  DropDownController,
  GradingController,
  GradeFrameController,
} from '@/services/request.service'
import moment from 'moment'
import debounce from 'lodash/debounce'
import { getRoleType } from '@/utils/utils'

@Component
export default class AssessmentFrame extends Vue {
  private loading = false
  private assessmentFrames: Array<any> = []
  private currentFrameId: Array<any> = []
  private sections: Array<any> = []
  private schoolYears: Array<any> = []
  private filters: any = {
    assessmentSheetName: '',
    schoolYear: '',
  }
  private assessmentSheets: Array<any> = []
  private frameType = '1310'

  private moment = moment

  private get assessmentSheetHeader(): Array<any> {
    return [
      {
        title: this.$t('assessmentFrame.assessmentSheet'),
        scopedSlots: {
          customRender: 'name',
        },
      },
      {
        title: this.$t('assessmentFrame.section'),
        dataIndex: 'sectionName',
      },
      {
        title: this.$t('assessmentFrame.skillNum'),
        dataIndex: 'skillNum',
      },
      this.frameType === '1310'
        ? {
            title: this.$t('assessmentFrame.status'),
            scopedSlots: {
              customRender: 'status',
            },
          }
        : {
            width: 0,
          },
      {
        title: this.$t('assessmentFrame.modifier'),
        dataIndex: 'modifier',
      },
      {
        title: this.$t('assessmentFrame.modifyTime'),
        scopedSlots: {
          customRender: 'modifyTime',
        },
      },
      {
        title: this.$t('common.operations'),
        scopedSlots: {
          customRender: 'operation',
        },
      },
    ]
  }

  private get isChildRoute(): boolean {
    return this.$route.name !== 'assessmentFrame'
  }

  private get roleType(): string {
    return getRoleType()
  }

  @Watch('$route')
  private onRouterChange(to: any, from: any): void {
    this.getAssessmentSheets()
  }

  private created(): void {
    this.getAssessmentFrames()
  }

  private getAssessmentFrames(): void {
    GradeFrameController.getGradeFrameList()
      .then(res => {
        this.assessmentFrames = res.data.gradeFrameList
        this.currentFrameId = [res.data.gradeFrameList[0].gradeFrameId]
        this.frameType = res.data.gradeFrameList[0].type
        this.getSchoolYears(res.data.gradeFrameList[0].gradeFrameId)
      })
      .catch(err => {
        console.error(err)
      })
  }

  private getSchoolYears(frameId): void {
    DropDownController.getSchoolYearByFrame(frameId)
      .then(res => {
        this.schoolYears = res.data
        this.$set(this.filters, 'schoolYear', res.data[0].key)
        this.getAssessmentSheets()
      })
      .catch(err => {
        console.error(err)
      })
  }

  private changeTab({ item, key, keyPath }): void {
    this.frameType = this.assessmentFrames.filter(frame => frame.gradeFrameId === key)[0].type
    this.currentFrameId = [key]
    this.filters = {
      assessmentSheetName: '',
    }
    this.getSchoolYears(key)
  }

  private getAssessmentSheets(): void {
    this.loading = true
    const gradeFrameId = this.currentFrameId[0]
    const gradeTableName = this.filters.assessmentSheetName.trim() || undefined
    const schoolYear = this.filters.schoolYear
    GradeFrameController.getGradeTables(gradeFrameId, schoolYear, gradeTableName)
      .then(res => {
        this.assessmentSheets = res.data.map(item => {
          const { sections, ...sheet } = item
          return {
            ...sheet,
            sectionName: sections.map(item => item.name).join(', '),
            sectionId: sections.map(item => item.sectionId),
          }
        })
      })
      .catch(err => {
        console.error(err)
      })
      .finally(() => {
        this.loading = false
      })
  }

  private changeFilter = debounce(() => {
    this.getAssessmentSheets()
  }, 1000)

  private addSheet(): void {
    const gradeFrameId = this.currentFrameId[0].toString()
    const { schoolYear } = this.filters
    this.$router
      .push({ name: 'addAssessmentSheet', params: { gradeFrameId, schoolYear } })
      .catch(err => {})
  }

  private editSheet(gradeTableId): void {
    const { schoolYear } = this.filters
    this.$router
      .push({ name: 'editAssessmentSheet', params: { gradeTableId, schoolYear } })
      .catch(err => {})
  }

  private enableSheet(sectionId, gradeTableId): void {
    const gradeFrameId = this.currentFrameId[0]
    const { schoolYear } = this.filters
    GradingController.enableSectionTable(sectionId, gradeTableId, gradeFrameId, schoolYear)
      .then(res => {
        this.$message.success(this.$tc('common.enableSuccess'))
        this.getAssessmentSheets()
      })
      .catch(err => {
        console.error(err)
      })
  }

  private disableSheet(sectionId, gradeTableId): void {
    const gradeFrameId = this.currentFrameId[0]
    const { schoolYear } = this.filters
    GradingController.disableSectionTable(sectionId, gradeTableId, gradeFrameId, schoolYear)
      .then(res => {
        this.$message.success(this.$tc('common.disableSuccess'))
        this.getAssessmentSheets()
      })
      .catch(err => {
        console.error(err)
      })
  }

  private deleteRecord(sectionId, gradeTableId): void {
    GradingController.deleteGradeTable(gradeTableId, sectionId)
      .then(res => {
        this.$message.success(this.$tc('common.deleteSuccess'))
        this.getAssessmentSheets()
      })
      .catch(err => {
        console.error(err)
      })
  }

  private viewDetail(gradeTableId): void {
    const { schoolYear } = this.filters
    this.$router
      .push({ name: 'viewAssessmentSheet', params: { gradeTableId, schoolYear } })
      .catch(err => {})
  }

  private forbidEnable(sectionId): boolean {
    return (
      this.frameType === '1311' &&
      this.assessmentSheets
        .filter(sheet => sheet.sectionId === sectionId)
        .some(sheet => !sheet.disabled)
    )
  }
}
